export default __webpack_public_path__ + "static/media/expl-nn_13_EN.f22752f4.png";